import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { getProviderIpsStock } from "store/provider-dashboard/provider-dashboard-action"
import {
  getSelectedValues,
  searchObjectValueManager,
  setAllLabelToSelectBoxOption,
} from "utils/utils"

const ProviderIPsStockFilter = ({
  onCategoryChange,
  provIpsStockLoading,
  getSearchData,
  onProviderIPsAdvancedSearchHandler,
}) => {
  const providerIps = useSelector(state => state.providerDashboard.ProviderIps)
  const ProviderItems = useSelector(
    state => state.providerDashboard.ProviderItems
  )

  const projects = useSelector(
    state => state.providerDashboard.providerProjects
  )
  const ProviderItemCategoires = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  const filteredItems = useMemo(
    () =>
      ProviderItems?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [ProviderItems]
  )

  const dispatch = useDispatch()

  const fromdateFlatpicker = useRef(null)
  const todateFlatpicker = useRef(null)
  const [Ips, setIps] = useState(null)
  const [Categories, setCategories] = useState(null)
  const [item, setItem] = useState(null)
  const [batchNumber, setBatchNumber] = useState("")
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [project, setProject] = useState(null)

  const handleSubmit = () => {
    let searchs = {}
    const storeObjectValues = searchObjectValueManager(searchs)
    storeObjectValues("projects", project)
    storeObjectValues("categories", Categories)
    storeObjectValues("ips", Ips)
    storeObjectValues("item", item)
    searchs.batchNumber = batchNumber
    searchs.from = fromDate
    searchs.to = toDate
    onProviderIPsAdvancedSearchHandler(searchs)
    getSearchData({ Ips, Categories, item, batchNumber, fromDate, toDate })
    dispatch(getProviderIpsStock(searchs))
  }

  const IpsChangeHandler = ip => {
    setIps(getSelectedValues(ip, providerIps?.data))
  }

  const onCategoryChangeHandler = category => {
    const selectedValues = getSelectedValues(category, ProviderItemCategoires)
    const ids = selectedValues?.map(val => val.value)
    onCategoryChange(ids)
    setCategories(selectedValues)
  }

  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }

  const onProjectChangeHandler = proj => {
    setProject(getSelectedValues(proj, projects?.data))
  }

  const onClearHandler = () => {
    fromdateFlatpicker.current.flatpickr.clear()
    todateFlatpicker.current.flatpickr.clear()
    setIps(null)
    setCategories(null)
    setItem(null)
    setBatchNumber("")
    setFromDate(null)
    setToDate(null)
    setProject(null)
    getSearchData({ Ips, Categories, item, batchNumber, fromDate, toDate })
    dispatch(getProviderIpsStock())
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Projects</Label>
            {projects?.data && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(projects?.data)}
                value={project}
                onChange={onProjectChangeHandler}
              />
            )}
          </Col>
          <Col>
            {" "}
            <Label className="form-label">IPs</Label>
            {providerIps?.data && (
              <Select
                isMulti={true}
                options={setAllLabelToSelectBoxOption(providerIps?.data)}
                value={Ips}
                onChange={IpsChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Label className="form-label">Item Categories</Label>
        {ProviderItemCategoires?.data && (
          <Select
            isMulti={true}
            options={setAllLabelToSelectBoxOption(ProviderItemCategoires?.data)}
            value={Categories}
            onChange={onCategoryChangeHandler}
          />
        )}
      </div>

      {filteredItems && (
        <div className="mb-3">
          <Label className="form-label">Items</Label>
          <Select
            isMulti={true}
            options={[{ value: "all", label: "All" }, ...filteredItems]}
            value={item}
            onChange={onItemChangeHandler}
          />
        </div>
      )}
      <div className="mb-3">
        <Label className="form-label">Batch Number</Label>
        <Input
          name="name"
          value={batchNumber}
          onChange={value => {
            setBatchNumber(value.target.value)
          }}
          placeholder="Name"
          type="text"
        />
      </div>

      <div className="mb-3 ">
        <Label className="form-label">From Date</Label>
        <Flatpickr
          ref={fromdateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setFromDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
        <br />
        <Label className="form-label">To Date</Label>
        <Flatpickr
          ref={todateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setToDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
      </div>

      <div className="d-flex flex-wrap gap-2">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={provIpsStockLoading}
        >
          {provIpsStockLoading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderIPsStockFilter
